import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TokenResponse } from 'src/app/shared/models/token-response.model';
import { environment } from 'src/environments/environment';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(
      private http: HttpClient,
      private sessionService: SessionService
    ) {}

  private isExecutiveMode = (): boolean =>
        environment.mode === 'WEB-PF' || environment.mode === 'PF'

  public refreshToken(): Observable<TokenResponse> {
        const clientId = environment.bankingServer.clientId;
        const clientSecret = environment.bankingServer.clientSecret;
        const authHeader = btoa(`${clientId}:${clientSecret}`);
        let endpoint;
        if (this.isExecutiveMode()) {
            endpoint = `${environment.REFRESH_URL.OMNI2}${environment.bankingServer.base_path.omni2}${environment.bankingServer.oauth2Endpoint}`;
        } else {
            endpoint = `${environment.REFRESH_URL.OMNI1}${environment.bankingServer.base_path.omni1}${environment.bankingServer.oauth2Endpoint}`;
        }
        const body = `grant_type=refresh_token&refresh_token=${this.sessionService.refreshToken}`;
        const headers = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Authorization': `Basic ${authHeader}`,
                'channel': this.isExecutiveMode() ? 'PF' : 'IN'
            })
        };

        return this.http.post<TokenResponse>(endpoint, body, headers).pipe(
      map((response) => {
        return response;
      })
    );
  }
}
